// Shopify theme source for the photographic story enhancement.
(function () {
// Theme controller; Liquid owns the content and this script enhances presentation.
// Liquid owns images, text, links and order; enhancement only changes presentation.
function createPhotographicStory({ root }) {
  const view = root.ownerDocument.defaultView
  let shots = []
  let media
  let frame = null
  let initialized = false
  let keyboard = false
  let observer
  let previousCovers = []

  function clearPresentation() {
    previousCovers = []
    delete root.dataset.wmPhotoEnhanced
    shots.forEach((shot) => shot.style.removeProperty('--wm-photo-cover'))
  }

  function update() {
    frame = null
    if (!root.dataset.wmPhotoEnhanced) return
    // Read all rectangles before writing. No assumptions about frame count/order.
    const bounds = shots.map((shot) => shot.getBoundingClientRect())
    bounds.forEach((rect, index) => {
      const next = bounds[index + 1]
      const cover = next ? Math.max(0, Math.min(1, (rect.bottom - next.top) / Math.max(1, rect.height))) : 0
      const value = cover.toFixed(4)
      if (previousCovers[index] === value) return
      previousCovers[index] = value
      shots[index].style.setProperty('--wm-photo-cover', value)
    })
  }

  function schedule() {
    if (frame === null && root.dataset.wmPhotoEnhanced) frame = view.requestAnimationFrame(update)
  }

  function configure() {
    clearPresentation()
    if (media.matches && shots.length > 1 && !keyboard) root.dataset.wmPhotoEnhanced = 'true'
    schedule()
  }

  function onKey(event) {
    // Keyboard traversal uses the complete document flow, including optional links.
    if (event.key !== 'Tab' || keyboard) return
    keyboard = true
    configure()
  }

  function destroy() {
    if (frame !== null) view.cancelAnimationFrame(frame)
    frame = null
    media?.removeEventListener('change', configure)
    view.removeEventListener('scroll', schedule)
    view.removeEventListener('resize', schedule)
    view.removeEventListener('keydown', onKey)
    observer?.disconnect()
    observer = undefined
    clearPresentation()
    initialized = false
  }

  function init() {
    if (initialized) destroy()
    shots = [...root.querySelectorAll('[data-wm-movement-shot]')]
    media = view.matchMedia('(min-width: 1024px) and (min-height: 650px) and (prefers-reduced-motion: no-preference)')
    media.addEventListener('change', configure)
    view.addEventListener('scroll', schedule, { passive: true })
    view.addEventListener('resize', schedule, { passive: true })
    view.addEventListener('keydown', onKey)
    if (view.ResizeObserver) {
      observer = new view.ResizeObserver(schedule)
      observer.observe(root)
    }
    initialized = true
    configure()
    return controller
  }

  function refresh() { destroy(); return init() }
  const controller = { init, refresh, destroy }
  return controller
}

window.WagmadePhotographicStory = createPhotographicStory;
})();
